export default __webpack_public_path__ + "static/media/right_bottom.ddf94857.png";